import { decodeAssetID } from 'features/assets/assets.util';
import type { GetFilteredAssetsFn } from 'features/traffic/campaigns/campaign-configs/types';
import type { TrafficCampaignFormValues } from 'features/traffic/campaigns/content/generic.util';
import { getValuesWithPrefix } from 'features/traffic/campaigns/utils/asset-id-extractor';
import type { TContent } from '../types';

/**
 * Filters and returns a list of asset IDs that are present in the JsonText of the content section in a particular flavor.
 * @template T - The type of the `ConfigDrivenFlavorContent` object.
 *
 * @param {T} flavor - The `flavor` object, which contains the `content` property.
 * @returns {AssetPublishConfig[]} - An array of objects, where each object has an `assetId` property.
 * @throws {Error} - If any of the asset IDs within the `jsonText` property of the `content` object do not exist in the `campaignAssets` array of the `globalContent` object.
 */
export const getConfigDrivenFormFilteredAssets: GetFilteredAssetsFn<TContent, unknown | TrafficCampaignFormValues> = (flavor) => {
  const jsonText = flavor.content;
  const assetIDsWithinJsonText = getValuesWithPrefix(jsonText);
  const decodedAssetIds = assetIDsWithinJsonText.map((assetID) => decodeAssetID(assetID));
  return decodedAssetIds.map((assetId) => ({
    assetId,
  }));
};
